import { api, handleError } from "./baseApi";

export async function getTripDetails(filters = {}) {
  try {
    const { data } = await api.get("/reports", {
      params: {
        bus_id: filters.busId,
        date: filters.date,
      },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}
